import React from "react";
import TooltipIconList, {
  TooltipIconListItem,
} from "components/shared/TooltipIconList";

interface Logo {
  name: string;
  url?: string;
  iconifyClass?: string;
  skillName?: string;
}

interface ProjectLinksProps {
  logos: Logo[];
}

const ProjectLinks: React.FC<ProjectLinksProps> = (props) => {
  function openRepoinNewTab(url?: string) {
    if (!url || url === "#") return;
    const win = window.open(url, "_blank");
    if (win) win.focus();
  }

  const items: TooltipIconListItem[] = (props.logos ?? []).map(
    (logo, index) => ({
      id: `${logo.name}-${index}`,
      icon: logo.iconifyClass ?? "",
      tooltip: logo.name,
      dataName: logo.skillName,
      onClick:
        logo.url && logo.url !== "#"
          ? () => openRepoinNewTab(logo.url)
          : undefined,
    }),
  );

  return <TooltipIconList items={items} />;
};

export default ProjectLinks;
